import styled from 'styled-components';
import Mod001 from 'dc/Mod001';
import { Typ40, Typ50 } from 'dc/Typ';
import Btn021 from 'dc/Btn021';
import Btn022 from 'dc/Btn022';

export const Modal = styled(Mod001)`
  width: 646px !important;
  > div {
    border-radius: 5px;
    box-shadow:
      0 15px 20px rgba(0, 0, 0, 0.22),
      0 19px 60px rgba(0, 0, 0, 0.3);
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: transparent;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 32px;
`;

export const Heading = styled(Typ50)`
  width: 100%;
  padding-bottom: 16px;
  white-space: pre-wrap;
  color: #455a64;
  > div > span {
    padding-top: 0;
    font-size: 24px;
    line-height: 28px;
    font-weight: bold;
  }
`;

export const Content = styled(Typ40)`
  width: 90%;
  padding-bottom: 32px;
  color: #455a64;
`;

export const StartButton = styled(Btn021)`
  margin-bottom: 8px;
  width: 223px;
  background-color: #007079;
  box-shadow:
    0 2px 2px rgba(0, 0, 0, 0.24),
    0 0 4px rgba(0, 0, 0, 0.12);
`;

export const RevisitButton = styled(Btn022)`
  * {
    color: #007079;
  }
`;
